import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import api, { tokenStorage } from '../services/api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => tokenStorage.getToken());
  const [email, setEmail] = useState(() => tokenStorage.getEmail());
  const [loading, setLoading] = useState(false);

  // Validate token on mount/change
  useEffect(() => {
    if (!token) return undefined;
    let mounted = true;
    api.get('/auth/me').catch(() => {
      if (!mounted) return;
      tokenStorage.clear();
      setToken('');
      setEmail('');
    });
    return () => { mounted = false; };
  }, [token]);

  const login = useCallback(async (emailInput, password) => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email: emailInput, password });
      tokenStorage.set(data.access_token, data.email);
      setToken(data.access_token);
      setEmail(data.email);
      return true;
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    tokenStorage.clear();
    setToken('');
    setEmail('');
  }, []);

  const value = useMemo(
    () => ({ token, email, isAuthed: !!token, login, logout, loading }),
    [token, email, login, logout, loading]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
